import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GenericApiService } from '@pm-ui/core-services';
//import { ILevelMasterVM } from '@pm-ui/pm-services';
import { Observable } from 'rxjs';
import { LevelEndpoints } from '../../config/levels/level-end-point';

@Injectable({
  providedIn: 'root'
})
export class LevelService {

  constructor(private genericApiService: GenericApiService,private _http: HttpClient) { }

  getLevels<T>(reqModel:any): Observable<any>{        
    return this.genericApiService.post(LevelEndpoints.GetLevels, reqModel);
 }

 getLevelById<T>(id: number): Observable<HttpResponse<T>> {
  return this.genericApiService.get<T>(`${LevelEndpoints.GetLevelById}/${id}`);
}


getLevelByBuildingId<T>(id: number,SiteId:number): Observable<HttpResponse<T>> {
  return this.genericApiService.get<T>(`${LevelEndpoints.getLevelByBuildingId}/${id}/${SiteId}`);
}

addLevel<T>(model: any): Observable<HttpResponse<T>> {
  return this.genericApiService.post(LevelEndpoints.SaveLevel, model);
}

updateLevel<T>(model: any): Observable<HttpResponse<T>> {
  return this.genericApiService.post(LevelEndpoints.UpdateLevel, model);
}

deleteLevel<T>(LevelId: number,SiteId:number): Observable<HttpResponse<T>> {
  return this.genericApiService.delete(`${LevelEndpoints.DeleteLevel}/${LevelId}/${SiteId}`);
}

checkDeleteInactiveLevels<T>(LevelId: number): Observable<HttpResponse<T>> {
  return this.genericApiService.delete(`${LevelEndpoints.checkDeleteInactiveLevel}/${LevelId}`);
}

getBuilding<T>(siteId: any,buildingId:number): Observable<any>{  
  return this.genericApiService.get<T>(`${LevelEndpoints.GetBuilding}/${siteId}/${buildingId}`);      
  //return this.genericApiService.get(LevelEndpoints.GetBuilding);
}

}
